import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AssignedWebsite } from '../models/staff-access.model';

@Injectable({ providedIn: 'root' })
export class StaffSitesService {
  constructor(private http: HttpClient) {}
  assigned(): Observable<AssignedWebsite[]> {
    return this.http.get<AssignedWebsite[]>(`${environment.subscriptionApiUrl}/api/admin/sites/assigned`);
  }
  builderUrl(businessId: string): string {
    return `${environment.posWebUrl}/${encodeURIComponent(businessId)}/website-builder`;
  }
}
